var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBsPausedQueue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4.998 15H3.002A3 3 0 0 1 0 12V3c0-1.657 1.339-3 3.002-3h1.996A3 3 0 0 1 8 3c0-1.657 1.339-3 3.002-3h1.996A3 3 0 0 1 16 3v9c0 1.657-1.339 3-3.002 3h-1.996A3 3 0 0 1 8 12c0 1.657-1.339 3-3.002 3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M5.002 1C6.106 1 7 1.894 7 3.003v8.994A2.003 2.003 0 0 1 5.002 14H2.998A2 2 0 0 1 1 11.997V3.003C1 1.897 1.898 1 2.998 1zm8 0C14.106 1 15 1.894 15 3.003v8.994A2.003 2.003 0 0 1 13.002 14h-2.004A2 2 0 0 1 9 11.997V3.003C9 1.897 9.898 1 10.998 1z"
}))));
export default SvgBsPausedQueue;